module.exports = __webpack_public_path__ + "img/main_tnbox_service_02_2.1be2d0cb.svg";